import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Databases from './pages/Databases';
import Logs from './pages/Logs';
import './App.css';

function Layout() {
  const { user, logout, loading } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [page, setPage] = useState(() => {
    const h = window.location.hash.replace(/^#/, '');
    return h === 'logs' ? 'logs' : 'databases';
  });

  useEffect(() => {
    if (!window.location.hash) {
      window.location.hash = '#databases';
    }
  }, []);

  useEffect(() => {
    if (!user || loading) return;
    if (!isAdmin && window.location.hash === '#logs') {
      window.location.hash = '#databases';
    }
  }, [user, loading, isAdmin]);

  useEffect(() => {
    const onHash = () => {
      const h = window.location.hash.replace(/^#/, '');
      setPage(h === 'logs' ? 'logs' : 'databases');
    };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  function goNav(next) {
    window.location.hash = next === 'logs' ? '#logs' : '#databases';
  }

  const showLogsPage = page === 'logs' && isAdmin;

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <div className="app">
      <header className="topnav" role="banner">
        <div className="topnav-brand">
          <div className="topnav-brand-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
              <ellipse cx="12" cy="8" rx="8" ry="3.5" stroke="currentColor" strokeWidth="1.5" />
              <path d="M4 8v4c0 2.21 3.58 4 8 4s8-1.79 8-4V8" stroke="currentColor" strokeWidth="1.5" />
              <path d="M4 12v4c0 2.21 3.58 4 8 4s8-1.79 8-4v-4" stroke="currentColor" strokeWidth="1.5" opacity="0.45" />
            </svg>
          </div>
          <span>DB Manager</span>
        </div>

        <nav className="topnav-nav" aria-label="Main">
          <button
            type="button"
            className={`nav-link${!showLogsPage ? ' nav-link-active' : ''}`}
            onClick={() => goNav('databases')}
          >
            Databases
          </button>
          {isAdmin && (
            <button
              type="button"
              className={`nav-link${page === 'logs' ? ' nav-link-active' : ''}`}
              onClick={() => goNav('logs')}
            >
              Logs
            </button>
          )}
        </nav>

        <div className="topnav-actions">
          <div className="session-pill">
            <span className="session-dot" />
            Signed in · {isAdmin ? 'Admin' : 'Developer'}
          </div>
          <button type="button" className="btn btn-ghost btn-xs" onClick={logout}>
            Sign out
          </button>
        </div>
      </header>

      <main className="main-content">
        {showLogsPage ? <Logs /> : <Databases />}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Layout />
    </AuthProvider>
  );
}
